var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreIconRokkApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.416577 0.375244C0.104213 0.694482 9.15527e-05 1.22654 9.15527e-05 1.86502V25.3822C9.15527e-05 26.0207 0.208334 26.5527 0.520698 26.872L0.62482 26.9784L13.5359 13.7832V13.5704L0.416577 0.375244Z",
    fill: "url(#paint0_linear_214_693)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7004 18.2528L13.4314 13.8899V13.5707L17.7004 9.20776L17.8045 9.31418L22.9065 12.2937C24.3642 13.145 24.3642 14.5284 22.9065 15.3797L17.7004 18.2528Z",
    fill: "url(#paint1_linear_214_693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.805 18.1466L13.432 13.6772L0.416779 26.9788C0.937385 27.5109 1.66624 27.5109 2.60333 27.0852L17.805 18.1466Z",
    fill: "url(#paint2_linear_214_693)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.805 9.20744L2.60333 0.375196C1.66624 -0.156867 0.937385 -0.0504546 0.416779 0.481608L13.432 13.6768L17.805 9.20744Z",
    fill: "url(#paint3_linear_214_693)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.7009 18.0396L2.60333 26.7654C1.77036 27.2974 1.04151 27.191 0.5209 26.7654L0.416779 26.8718L0.5209 26.9782C1.04151 27.4039 1.77036 27.5103 2.60333 26.9782L17.7009 18.0396Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.416577 26.766C0.104213 26.4468 9.15527e-05 25.9147 9.15527e-05 25.2762V25.3826C9.15527e-05 26.0211 0.208334 26.5532 0.520698 26.8724V26.766H0.416577ZM22.9068 15.0606L17.7007 18.0402L17.8048 18.1466L22.9068 15.167C23.6356 14.7414 23.948 14.2093 23.948 13.6772C23.948 14.2093 23.5315 14.635 22.9068 15.0606Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2.60303 0.481846L22.9067 12.2936C23.5314 12.7193 23.9479 13.1449 23.9479 13.677C23.9479 13.1449 23.6356 12.6129 22.9067 12.1872L2.60303 0.375434C1.14534 -0.475867 0 0.162608 0 1.86521V1.97162C0 0.375434 1.14534 -0.369454 2.60303 0.481846Z",
    fill: "#101010"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_693",
    x1: 12.2864,
    y1: 1.66284,
    x2: -5.56855,
    y2: 19.1323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_693",
    x1: 24.8161,
    y1: 13.6782,
    x2: -0.378193,
    y2: 13.6782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_693",
    x1: 15.4384,
    y1: 16.1205,
    x2: -8.77326,
    y2: 39.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_214_693",
    x1: -2.81411,
    y1: -7.41846,
    x2: 7.99804,
    y2: 3.16089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIconRokkApp);
export default __webpack_public_path__ + "static/media/play_store_icon_rokk_app.af14a5684a1b362f470d7248daf83add.svg";
export { ForwardRef as ReactComponent };